import { PropType, defineComponent, onUnmounted, ref, watch } from 'vue'
import { Store } from 'pinia'
import { IBackList } from './backList'
import { useRoute, useRouter } from 'vue-router'
import { ComponentActions, ComponentState } from '../../nsh5/localStores/component'

/**
 * 回退记录功能模块
 */
export default defineComponent({
  name: 'back-list-record-view',
  props: {
    componentStore: {
      // 用于同一项目功能模块间的通信
      type: Object as PropType<Store<string, ComponentState, {}, ComponentActions>>,
      default: null,
    },
  },
  setup: (props) => {
    const route = useRoute()
    const router = useRouter()
    const backList = ref<IBackList[]>([]) // 用于记录回退数据

    props.componentStore.bus.on('getBackList', () => backList)
    /**
     * 添加回退路径
     */
    const pushBackList = (history: IBackList) => {
      backList.value.push(history)
    }
    props.componentStore.bus.on('pushBackList', pushBackList)

    /**
     * 替换最后一个list，用于有搜索的情况下再点击其他icon点
     * @param history
     */
    const replaceLastBackList = (history: IBackList) => {
      backList.value.splice(backList.value.length - 1, 1, history)
    }
    props.componentStore.bus.on('replaceLastBackList', replaceLastBackList)

    /**
     * pop最后一个list
     * @returns
     */
    const popBackList = () => {
      return backList.value.pop()
    }
    props.componentStore.bus.on('popBackList', popBackList)

    /**
     * 清除回退路径, 关闭按钮后需要清除
     */
    const clearBackList = () => {
      if (props.componentStore.tempSearchPoiResource) {
        backList.value = backList.value.slice(0, 1)
      } else {
        // 搜索情况下，只保留第一个记录
        backList.value = []
      }
    }
    props.componentStore.bus.on('clearBackList', clearBackList)

    /**
     * 清空回退路径
     */
    const forceClearBackList = () => {
      backList.value = []
    }
    props.componentStore.bus.on('forceClearBackList', forceClearBackList)

    const iconOperateBackList = (params: { routeTarget: IBackList; fromDetailToIcon: boolean }) => {
      const { routeTarget, fromDetailToIcon } = params
      if (props.componentStore.tempSearchPoiResource) {
        // 搜索模式下点击icon都不清除backList，因为有一条搜索记录的back route
        // ! 搜素模式下 不能戳点 所以不用考虑icon到pin的切换
        // 替换最后一条记录
        if (backList.value.length >= 1 && backList.value[0].query.id === routeTarget.query.id) {
          // 当前点击的点是第一个点， 只保留第一条数据
          clearBackList()
          return
        }
        if (backList.value.length === 2) {
          replaceLastBackList(routeTarget)
        } else {
          if (fromDetailToIcon) {
            // 从详情里跳转到icon，不需要清除backList，而是push最后一条记录
            pushBackList(routeTarget)
          } else {
            // 不从详情页跳转到另外一个icon，而是从地图上直接打开一个icon，需要清除backList
            clearBackList()
            pushBackList(routeTarget)
          }
        }
      } else {
        // 非搜索模式下
        if (fromDetailToIcon) {
          // 从详情页跳转到另外一个icon，不需要清除backList，而是push
          pushBackList(routeTarget)
        } else {
          if (route.name === 'home') {
            // 从首页点击，即为第一次点击，需要记录第一个点
            pushBackList(routeTarget)
          } else {
            // 从非首页点击，即为切换icon，需要清除backList，并重新记录当前点击的点
            // 不从详情页跳转到另外一个icon，而是从地图上直接打开一个icon，需要清除backList
            clearBackList()
            pushBackList(routeTarget)
          }
        }
      }
    }
    props.componentStore.bus.on('iconOperateBackList', iconOperateBackList)

    /**
     * 点击后退按钮
     */
    const handleBackButton = async () => {
      // 倒数第二个就是上一个页面，如果只有一个是没有后退按钮的
      popBackList()
      const lastBack = backList.value[backList.value.length - 1]
      await router.replace(lastBack)
      props.componentStore.bus.emit('backResourceRoute')
      props.componentStore.bus.emit('backPinRoute')
    }
    props.componentStore.bus.on('handleBackButton', handleBackButton)

    onUnmounted(() => {
      backList.value = []
      props.componentStore.bus.off('getBackList')
      props.componentStore.bus.off('pushBackList')
      props.componentStore.bus.off('replaceLastBackList')
      props.componentStore.bus.off('popBackList')
      props.componentStore.bus.off('clearBackList')
      props.componentStore.bus.off('forceClearBackList')
      props.componentStore.bus.off('iconOperateBackList')
      props.componentStore.bus.off('handleBackButton')
    })

    watch(
      () => backList.value,
      () => {
        props.componentStore.$patch({ backList: backList.value })
      },
      {
        deep: true,
      }
    )

    return () => {}
  },
})
